import NodeCache from 'node-cache';
import api from '@motionelements/core/src/api/base-api-v2';

let cache = null;

if (process.server) {
  cache = new NodeCache({ stdTTL: 600 });
}

/**
 * Laravel-style remember: return cached value or run fetcher, cache, and return.
 * Server-only; on client, always runs fetcher (no cache).
 *
 * @param {string} key - Cache key
 * @param {Function} fetcher - Async or sync function that returns the value to cache
 * @returns {Promise<any>} Cached or freshly fetched value
 */
// eslint-disable-next-line import/prefer-default-export
export function remember(key, fetcher) {
  if (!process.server || !cache) {
    return Promise.resolve(fetcher());
  }

  const { language = 'en' } = api.getLocaleParams() || {};
  const cacheKey = `${key}_${language}`;

  const cached = cache.get(cacheKey);
  if (cached !== undefined) return Promise.resolve(cached);

  return Promise.resolve(fetcher()).then((value) => {
    cache.set(cacheKey, value);
    return value;
  });
}
